/**
 * Onde um cartão de novidade é desenhado. O servidor manda `surface` em cada cartão: `menu` (ao lado do item do menu), `home`
 * (destaque na tela inicial) ou `both`. Cartão de antes do campo (cliente mais novo que o servidor, teste antigo) vale `menu`,
 * que é o comportamento original.
 */
export const SPOTLIGHT_SURFACE_VALUES = Object.freeze(['menu', 'home', 'both']);

/** O cartão aparece ao lado do item do menu? */
export const showsOnMenu = (card) => (card?.surface ?? 'menu') !== 'home';

/** O cartão aparece como destaque na tela inicial? */
export const showsOnHome = (card) => card?.surface === 'home' || card?.surface === 'both';
